import { render, staticRenderFns } from "./TaxesOverview.vue?vue&type=template&id=6e7778ed&scoped=true&"
import script from "./TaxesOverview.vue?vue&type=script&lang=js&"
export * from "./TaxesOverview.vue?vue&type=script&lang=js&"
import style0 from "./TaxesOverview.vue?vue&type=style&index=0&id=6e7778ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7778ed",
  null
  
)

export default component.exports